export default "__VITE_ASSET__auJqOxoE__"